/**
 * Highlights section (used for 2020 Highlights, PAGE Impact on Homepage)
 */

import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import parse from "html-react-parser";
import { kebabCase, startCase } from "lodash";
import ExpandableGroup from "./expandable-group";
import CopyLinkButton from "./copy-link-button";

const ExpandableGroups = ({ props }) => {
  const data = useStaticQuery(graphql`
    {
      allWpCountry(sort: {date: ASC}) {
        nodes {
          uri
          title
          customSections {
            customsections {
              ... on WpCountry_Customsections_Customsections_Expandablegroups {
                groups {
                  leadContent
                  heading
                  backgroundColor
                  expandableBlock {
                    heading
                    expandedContent
                  }
                }
                fieldGroupName
              }
            }
          }
        }
      }
    }
  `);
  const countries = data?.allWpCountry?.nodes;
  return (
    <section className="section m-section" key={`outcomes-all-countries`}>
      <div className="container">
        <div className="group-copy-link group">
          {props.heading ? (
            <>
              <h2
                className="anchor-heading mb-8 text-center"
                id={kebabCase(props.heading).replace(/[0-9]/g, '')}
                data-sal="slide-up"
                data-sal-delay="300"
              >
                {parse(startCase(props.heading).replace("And", "and"))}
              </h2>
              <CopyLinkButton heading={props.heading} />
            </>
          ) : props.includeInStickyMenu?.menuTitle ? (
            <div id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}>
              <CopyLinkButton heading={props.includeInStickyMenu.menuTitle} />
            </div>
          ) : null}
        </div>
      </div>
      <nav className="sticky-menu bg-white">
        <h2 className="hidden container print:block">Table of Contents</h2>
        <ol className="sticky-menu-list">
          {countries?.map((country) => {
            return (
              <>
                {country?.customSections?.customsections?.map(
                  (customSection) => {
                    return (
                      <>
                        {customSection.fieldGroupName ===
                          "country_Customsections_Customsections_Expandablegroups" && (
                          <>
                            {customSection?.groups?.map((group) => {
                              return (
                                <>
                                  {group.heading === props.heading && (
                                    <li
                                      className=""
                                      data-sal="slide-up"
                                      data-sal-delay="300"
                                    >
                                      <Link
                                        className="sticky-menu-list-item bg-gray-100"
                                        to={`#${kebabCase(country.title)}`}
                                      >
                                        {parse(country.title)}
                                      </Link>
                                    </li>
                                  )}
                                </>
                              );
                            })}
                          </>
                        )}
                      </>
                    );
                  }
                )}
              </>
            );
          })}
        </ol>
      </nav>
      <dl
        className={`container mt-10 ${
          props.modalOrExpandable === "expandable"
            ? "divide-y divide-gray-300"
            : ""
        } gap-y-12 grid lg:grid-cols-${props.columnCount}`}
      >
        {countries?.map((country) => {
          return (
            <>
              {country?.customSections?.customsections?.map((customSection) => {
                return (
                  <>
                    {customSection.fieldGroupName ===
                      "country_Customsections_Customsections_Expandablegroups" && (
                      <>
                        {customSection?.groups?.map((group) => {
                          return (
                            <>
                              {group.heading === props.heading && (
                                <ExpandableGroup
                                  props={country}
                                  group={group}
                                />
                              )}
                            </>
                          );
                        })}
                      </>
                    )}
                  </>
                );
              })}
            </>
          );
        })}
      </dl>
    </section>
  );
};

export default ExpandableGroups;
